import { globalStore, singularityStore } from "@/store/store";
import { saveAiSettings } from "@/lib/ai/api";
import { updateSiteDescription, updateSiteTitle } from "./helpers";
import { FutureLayerSettings } from "./types";
import { fetchWithJWT } from "@/futurelayer/auth/jwt";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";

export type FutureLayerAISettings = {
  title: string;
  description: string;
};

export function getFutureLayerAISettings(): FutureLayerAISettings {
  return {
    title: globalStore.aiSettings.prompt.businessName || "",
    description: globalStore.aiSettings.prompt.businessDescription || ""
  };
}
export async function updateSiteTitleOnFutureLayerApp(title: string): Promise<void> {
  try {
    const response = await fetchWithJWT("/sites/update-title", {
      body: jsonStringifyOrUndefined({ title })
    });

    if (!response.ok) {
      console.error("Failed to update site title on FutureLayer:", response.status);
    }
  } catch (error) {
    console.error("Error updating site title on FutureLayer:", error);
  }
}

export async function saveFutureLayerAISettingsToGlobalStoreAndWordPress(internalAiSettings: FutureLayerAISettings): Promise<void> {
  updateSiteTitle(internalAiSettings.title);
  updateSiteDescription(internalAiSettings.description);
  await saveAiSettings();
  await updateSiteTitleOnFutureLayerApp(internalAiSettings.title);
}

export function placeFutureLayerSettingsInStore(settings: FutureLayerSettings): void {

  if (!settings) return;
  
  singularityStore.setHomepageInWP(settings.homepageId);
  singularityStore.setSiteStatus({
    isClaimed: settings.isClaimed,
    claimUrl: settings.claimUrl,
    siteState: settings.siteState
  });
}
